export default "__VITE_ASSET__acaf9eff__"